$(document).ready(function () {
    $('#sale-plan-form .help-block').remove();

    if ($('#sale-plan-form #initPriceCustom').val()) {
        $('.bn_commerce-construct-plan__content-form-input').addClass('filled')
    }
    $('#sale-plan-form .commission-control').each(function () {
        if ($(this).find('.commission-input:checked').length === 0) {
            $(this).addClass('undefined');
        }
    });
    $.planContructor.calculate();
    $(document).on('change', '#sale-plan-form .commission-input', function () {
        $(this).parents('.commission-control').removeClass('undefined');
        $.planContructor.calculate();
    })
    $(document).on('click', '#submit_terms_form', function () {
        $(this).html(
            $('#submit_terms_form_btn_text').html() +
            '&nbsp;&nbsp;&nbsp;<img src="/common/img/loader.gif" width="20">'
        );
        $(this).attr('disabled', 'disabled');
        setTimeout(function () {
            $('#sale-plan-form').submit();
        }, 1000);
    })
    $(document).on('focus', '#sale-plan-form #initPriceCustom', function () {
        $('#initialsellingPrices input[type="radio"]').removeAttr('checked');
    });
    $(document).on('keypress', '#sale-plan-form #initPriceCustom', function (e) {
        if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) {
            return false
        };
    });
    $(document).on('change', '#initialsellingPrices input[type="radio"]', function () {
        let input = $('.bn_commerce-construct-plan__content-form-input');

        input.val('');
        input.removeClass('filled');
    });
    $(document).on('blur', '.bn_commerce-construct-plan__content-form-input', function () {
        let that = $(this),
            value = that.val();

        if (value === '') {
            that.removeClass('filled');
            $('#initialsellingPrices input[type="radio"][data-selected]').first().prop("checked", true);
        } else {
            that.addClass('filled');
        }
    });
});

(function ($) {
    $.planContructor = {
        calculate: function () {
            let percent = 0,
                commissionClient = $('.commission-client'),
                commissionCompany = $('.commission-company'),
                commissionClientValue = parseInt(commissionClient.data('default')),
                commissionCompanyValue = parseInt(commissionCompany.data('default'));

            $('.commission-input:checked').each(function () {
                percent = percent + parseInt($(this).data('percent'));
            });

            commissionClient.text(commissionClientValue - percent);
            commissionCompany.text(commissionCompanyValue + percent);
            if ($('#sale-plan-form .commission-control.undefined').length === 0) {
                $('.commission-error').remove();
                $('.commission-submit').removeAttr('disabled');
            }
        }
    }
})(jQuery);
